module.exports = __webpack_public_path__ + "img/erweima_zf.db6cecd2.png";